<template>
    <div class="input-container">
        <input
            class="text-input"
            type="number"
            :id="id"
            :value="modelValue"
            v-on:input="$emit('update:modelValue', $event.target.value)"
            required
        />
        <label :for="id" class="label">
            <span>{{ label }}</span>
        </label>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    data() {
        return { inputValue: this.value };
    },
    computed: {
        id() {
            return `number-input-${this.label.replace(/\s+/g, '-').toLowerCase()}`;
        }
    },
    props: {
        label: {
            type: String,
            required: true,
        },
        modelValue: {
            type: Number,
            required: true,
        },
    },
});
</script>

<style scoped>
.input-container {
    height: 16px;
    position: relative;
    display: flex;
    border: 1px solid var(--medium-dark-grey);
    border-radius: 4px;
    padding: 11px 12px;
    align-items: center;
}
.text-input {
    font-family: 'Roboto';
    opacity: 0.87;
    border: none;
    outline: none;
    flex: 1;
    color: var(--black);
    padding-left: 8px;
}
input:not(:focus):not(:valid) ~ .label {
    height: 20px;
    top: calc(50% - 11px);
    font-size: var(--font-size-low-medium);
}
.label {
    height: 12px;
    display: flex;
    align-items: center;
    position: absolute;
    pointer-events: none;
    left: 12px;
    top: -7px;
    transition: 0.2s ease all;
    padding: 2px;
    background-color: var(--white);
    color: var(--medium-dark-grey);
    font-size: var(--font-size-very-small);
}
span {
    font-family: 'Roboto';
}
</style>
